<app-modal-shell
  [title]="'SCHOOL_DATA.TITLE'"
  [cancelLabel]="'SCHOOL_DATA.BUTTONS.CANCEL'"
  [saveLabel]="'SCHOOL_DATA.BUTTONS.OK'"
  (cancelClicked)="cancel()"
  (saveClicked)="save()">

  @if (form) {
    <div class="m-4">
      <div class="form-group sfk-form-vertical-spacer group-for-schoolId col mt-0 mb-0">
        <app-custom-select
          id="schoolId"
          [class]="'sfk-ellipsed-ng-select'"
          [customFormGroup]="form"
          placeholder="-"
          [items]="schuleList"
          [multiple]="false"
          [clearable]="false"
          bindLabel="name"
          bindValue="id"
          [label]="'SCHOOL_DATA.SCHOOL' | translate"
          data-cy="schule"
        ></app-custom-select>
      </div>

      <div class="form-group sfk-form-vertical-spacer group-for-schoolType col mt-0 mb-0">
        <app-custom-select
          id="schoolType"
          [class]="'sfk-ellipsed-ng-select'"
          [customFormGroup]="form"
          [items]="optionSchoolType"
          [multiple]="false"
          bindLabel="name"
          bindValue="id"
          [label]="'SCHOOL_DATA.SCHOOL_TYPE' | translate"
          [readonly]="true"
          data-cy="schoolType"
        ></app-custom-select>
      </div>

      @if (isBerufskolleg(getFormItem('schoolId')?.value)) {
        <div class="form-group sfk-form-vertical-spacer group-for-bildungsgangId col mt-0 mb-0">
          <app-custom-select
            id="courseId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            [placeholder]="!getFormItem('schoolId')?.value ? ('SCHOOL_DATA.SELECT_SCHOOL_FIRST' | translate) : '-'"
            [items]="filteredBildungsgangList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            [label]="'SCHOOL_DATA.COURSE' | translate"
            [noteText]="'SCHOOL_DATA.FIELD_ERROR.REQUIRED' | translate"
            data-cy="bildungsgang"
          ></app-custom-select>
        </div>
      }

      @if (getFormItem('schoolId')?.value) {
        <div class="form-group sfk-form-vertical-spacer group-for-schuljahr col mt-0 mb-0">
          <app-custom-select
            id="schoolYearId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            placeholder="-"
            [items]="filteredSchuljahreList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            [label]="'SCHOOL_DATA.SCHOOL_YEAR' | translate"
            [noteText]="'SCHOOL_DATA.FIELD_ERROR.REQUIRED' | translate"
            data-cy="schuljahr"
          ></app-custom-select>
        </div>
      }

      @if (getFormItem('schoolId')?.value && !isBerufskolleg(getFormItem('schoolId')?.value)) {
        <div class="form-group sfk-form-vertical-spacer group-for-klasseId col mt-0 mb-0">
          <app-custom-select
            id="classId"
            [class]="'sfk-ellipsed-ng-select'"
            [customFormGroup]="form"
            [placeholder]="!getFormItem('schoolId')?.value ? ('SCHOOL_DATA.SELECT_SCHOOL_FIRST' | translate) : '-'"
            [items]="filteredKlassenList"
            [multiple]="false"
            [clearable]="false"
            bindLabel="name"
            bindValue="id"
            [label]="'SCHOOL_DATA.KLASSE' | translate"
            [noteText]="'SCHOOL_DATA.FIELD_ERROR.REQUIRED' | translate"
            data-cy="klasse"
          ></app-custom-select>
        </div>
      }
    </div>
  }

</app-modal-shell>
